
(function(){
  'use strict';

  function init(root){
    if(!root || root.dataset.lflPremierInit==='true') return;
    root.dataset.lflPremierInit='true';

    /* Gallery */
    var mainImg=root.querySelector('#mainImage');
    root.querySelectorAll('.thumb[data-src]').forEach(function(btn){
      btn.addEventListener('click',function(){
        if(!mainImg)return;
        root.querySelectorAll('.thumb').forEach(function(x){x.classList.remove('active');});
        btn.classList.add('active');
        mainImg.src=btn.getAttribute('data-src');
      });
    });

    /* Shopify live variant synchronization */
    var form=root.querySelector('#lfl-premier-product-form');
    var variantInput=root.querySelector('[data-variant-input]');
    var currentPrice=root.querySelector('[data-current-price]');
    var comparePrice=root.querySelector('[data-compare-price]');
    var saveBadge=root.querySelector('[data-save-badge]');
    var add=root.querySelector('[data-add-to-cart]');
    var finalPrice=root.querySelector('[data-final-price]');
    var finalCompare=root.querySelector('[data-final-compare]');
    var finalAdd=root.querySelector('[data-final-add]');

    function selectVariant(id){
      var source=root.querySelector('.buy .size[data-variant-id="'+id+'"]');
      if(!source || source.disabled) return;

      root.querySelectorAll('.size[data-variant-id]').forEach(function(b){
        var on=b.getAttribute('data-variant-id')===id;
        b.classList.toggle('active',on);
        b.setAttribute('aria-pressed',on?'true':'false');
      });

      if(variantInput) variantInput.value=id;

      var price=source.getAttribute('data-variant-price')||'';
      var compare=source.getAttribute('data-variant-compare')||'';
      var save=source.getAttribute('data-variant-save')||'';
      var available=source.getAttribute('data-variant-available')==='true';

      if(currentPrice) currentPrice.textContent=price;
      if(finalPrice) finalPrice.textContent=price;

      if(comparePrice){
        comparePrice.hidden=!compare;
        comparePrice.textContent=compare||'';
      }
      if(finalCompare){
        finalCompare.hidden=!compare;
        finalCompare.textContent=compare||'';
      }
      if(saveBadge){
        saveBadge.hidden=!save;
        saveBadge.textContent=save?('SAVE '+save):'';
      }

      [add,finalAdd].forEach(function(b){
        if(!b)return;
        b.disabled=!available;
        b.textContent=available?'Add to Cart':'Sold Out';
      });

      if(window.history && window.history.replaceState){
        try{
          var u=new URL(window.location.href);
          u.searchParams.set('variant',id);
          window.history.replaceState({},'',u.toString());
        }catch(e){}
      }
    }

    root.querySelectorAll('.buy .size[data-variant-id]').forEach(function(btn){
      btn.addEventListener('click',function(){selectVariant(btn.getAttribute('data-variant-id'));});
    });
    root.querySelectorAll('[data-final-size]').forEach(function(btn){
      btn.addEventListener('click',function(){selectVariant(btn.getAttribute('data-variant-id'));});
    });

    if(finalAdd){
      finalAdd.addEventListener('click',function(){
        if(!form || finalAdd.disabled)return;
        if(form.requestSubmit)form.requestSubmit();
        else form.submit();
      });
    }

    /* Position presets */
    var posImg=root.querySelector('#positionImage');
    var posTitle=root.querySelector('#positionTitle');
    var posCopy=root.querySelector('#positionCopy');
    root.querySelectorAll('[data-position]').forEach(function(btn){
      btn.addEventListener('click',function(){
        root.querySelectorAll('[data-position]').forEach(function(x){x.classList.remove('active');});
        btn.classList.add('active');
        if(posImg)posImg.src=btn.getAttribute('data-position-src');
        if(posTitle)posTitle.textContent=btn.getAttribute('data-position-title')||btn.textContent.trim();
        if(posCopy)posCopy.textContent=btn.getAttribute('data-position-description')||'';
      });
    });

    /* Split King left/right focus */
    var splitPhoto=root.querySelector('#splitPhoto');
    root.querySelectorAll('[data-split]').forEach(function(btn){
      btn.addEventListener('click',function(){
        root.querySelectorAll('[data-split]').forEach(function(x){x.classList.remove('active');});
        btn.classList.add('active');
        if(splitPhoto){
          var img=splitPhoto.querySelector('img');
          if(img)img.style.transform=btn.getAttribute('data-split')==='left'?'scaleX(-1)':'none';
        }
      });
    });

    /* FAQ */
    root.querySelectorAll('details').forEach(function(d){
      d.addEventListener('toggle',function(){
        var s=d.querySelector('summary span');
        if(s)s.textContent=d.open?'−':'+';
      });
    });
  }

  function initAll(){
    document.querySelectorAll('.lfl-premier-pdp').forEach(init);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);
  else initAll();

  document.addEventListener('shopify:section:load',function(e){
    var root=e.target.querySelector('.lfl-premier-pdp');
    if(root)init(root);
  });
})();
